export default __webpack_public_path__ + "static/media/about-box.467ae900.png";